import React from 'react'

export function DataCell (props) {


  const {
    children,
    rowSpan = 2,
    colSpan = 2,
    componentName = 'div',
    componentStyles = {},
    ...rest
  } = props

  const cardStyle = {}

  if (rowSpan > 1) {
    cardStyle.gridRowEnd = `span ${rowSpan}`
  }

  if (colSpan === 0) {
    cardStyle.gridColumnStart = 1
    cardStyle.gridColumnEnd = -1
  } else if (colSpan > 1) {
    cardStyle.gridColumnEnd = `span ${colSpan}`
  }

  return React.createElement(componentName, {
    style: {
      ...componentStyles,
      ...cardStyle
    },
    ...rest
  }, children)
}

DataCell.DCType = 'Cell'
